import React from 'react'
import FontAwesome from 'react-fontawesome'
import { MISSION_STATE_FINISHED, MISSION_STATE_ACCEPTED,
  MISSION_STATE_LOCKED, MISSION_STATE_REJECT,
  MISSION_STATE_MAX_LIMIT,
} from '../../../../utils/constants'

const styles = {
  root: ((pcolor = '#000') => ({
    position: 'absolute',
    right: '20px',
    color: pcolor,
    fontSize: '20px',
  })),
  no_icon: {
    height: '9px',
    width: '14px',
  },
}

class MissionState extends React.Component {

  font = (color, name) =>
    <FontAwesome style={styles.root(color)} name={name} />

  render() {
    switch (this.props.missionState) {
      case MISSION_STATE_ACCEPTED:
        return this.font('#2DFC00', 'check-circle')
      case MISSION_STATE_MAX_LIMIT:
        return this.font('#2DFC00', 'check-circle')
      case MISSION_STATE_FINISHED:
        return this.font('#FFAF47', 'clock-o')
      case MISSION_STATE_REJECT:
        return this.font('#FF1A1A', 'times')
      case MISSION_STATE_LOCKED:
        return this.font('#E0E0E0', 'lock')
      default:
        return null
    }
  }
}

MissionState.propTypes = {
  missionState: React.PropTypes.number,
}

export default MissionState



// WEBPACK FOOTER //
// ./src/components/CampaignShow/MissionIndex/MissionState/index.jsx